import { Directive, HostListener, Input, Output, EventEmitter } from '@angular/core';
import startOfToday from 'date-fns/start_of_today';

/**
 * Change the view date to the current day. For example:
 *
 * ```typescript
 * &lt;button
 *  mwlCalendarToday
 *  [(viewDate)]="viewDate"&gt;
 *  Today
 * &lt;/button&gt;
 * ```
 */

export class CalendarTodayDirective {

  /**
   * The current view date
   */
   viewDate: Date;

  /**
   * Called when the view date is changed
   */
   viewDateChange: EventEmitter<Date> = new EventEmitter();

  /**
   * @hidden
   */
  
  onClick(): void {
    this.viewDateChange.emit(startOfToday());
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mwlCalendarToday]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'viewDate': [{ type: Input },],
'viewDateChange': [{ type: Output },],
'onClick': [{ type: HostListener, args: ['click', ] },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
